// External import
import React from "react";
import ReactDOM from "react-dom/client";

// Internal import
import "./style.css";
import App from "./app";

// Create root DOM
const root = ReactDOM.createRoot(document.getElementById("root"));

// Render application
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
